export default __webpack_public_path__ + "static/media/section2-bg.c6984d04.png";